//  FRONTEND

/* eslint-disable no-useless-escape */
//  Caracteres especiales permitidos, según el caso
const baseRegex = /^[a-zA-ZáéíóúÁÉÍÓÚüÜöÖñÑ\s'.,;"]+$/;
const baseRegexGeneralData = /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜöÖñÑ\s'.,;"&\-\/()]+$/;
const baseRegexDescription = /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜöÖñÑ .,;]+$/;

//  Agrupo condiciones para reutilizarlas
const checkExpressions = (value: string): void => {
  // espacios, tabs y enters consecutivos
  if (/\s{2,}/.test(value)) {
    throw new Error('No se permiten espacios consecutivos.');
  }

  // signos pegados
  if (/[\.,;\"\'&\-\/()]{2,}/.test(value)) {
    throw new Error('No se permiten caracteres especiales o de puntuación consecutivos.');
  }

  // Detecta si hay dos signos separados por un espacio
  // pero deja pasar " & " porque a los lados hay letras, no otros signos.
  if (/[\.,;\"\'&\-\/()]\s[\.,;\"\'&\-\/()]/.test(value)) {
    throw new Error('No se permiten caracteres especiales separados por un espacio.');
  }

  if (/[\.,;\"\'&\-\/() \t\r\n\v\f]$/.test(value)) {
    throw new Error('El texto no puede terminar con un espacio, signo de puntuación o carácter especial.');
  }
};

export const validateInputText = async (_: any, value: string | undefined): Promise<void> => {
  if (!value) return;

  if (!baseRegex.test(value)) {
    throw new Error('Contiene caracteres no válidos.');
  }

  checkExpressions(value);

  /* if ((value.match(/\./g) || []).length > 0) throw new Error('No se permiten puntos.');*/
};

export const validateGeneralData = async (_: any, value: string | undefined): Promise<void> => {
  if (!value) return;

  if (!baseRegexGeneralData.test(value)) {
    throw new Error('Contiene caracteres no válidos.');
  }

  checkExpressions(value);
};

export const validateDescriptionData = async (_: any, value: string | undefined): Promise<void> => {
  if (!value) return;

  if (!baseRegexDescription.test(value)) {
    throw new Error('Contiene caracteres no válidos. Solo se permiten letras, números, espacios, puntos y comas.');
  }

  checkExpressions(value);
};

export {};